import { useEffect, useState } from 'react';

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    function matchMedia() {
      const mediaQuery = window.matchMedia(query);
      setMatches(mediaQuery.matches);
    }

    matchMedia();

    window.addEventListener('resize', matchMedia);

    return function cleanup() {
      window.removeEventListener('resize', matchMedia);
    };
  }, []);

  return matches;
}
